import ProposalState from "../constants/ProposalState";
import { theme } from "../mui-customs/Theme";

function getStateData(state?: ProposalState | null, newText?: string) {
  let color;
  let text;
  switch (state) {
    case ProposalState.DRAFT:
      color = theme.grey2[500];
      text = newText || "Draft";
      break;
    case ProposalState.OPEN_BID:
      color = theme.purple[300];
      text = newText || "Open Bid";
      break;
    case ProposalState.NEW_GIG:
      color = theme.brand2[500];
      text = newText || "New Gig";
      break;
    case ProposalState.ACCEPTED_BOOKED:
      color = theme.brand1[500];
      text = newText || "Accepted Booked";
      break;
    case ProposalState.DEPOSIT_PAID:
      color = theme.brand1[500];
      text = newText || "Accepted Booked";
      break;

    case ProposalState.INVOICE_CHANGE:
      color = theme.yellow[500];
      text = newText || "Invoice Change";
      break;
    case ProposalState.FINISHED_AND_PAID:
      color = theme.brand1[700];
      text = newText || "Finished & Paid";
      break;
    case ProposalState.CANCELED_GIG:
      color = theme.red[300];
      text = newText || "Canceled Gig";
      break;
    case ProposalState.CANCELED_BID:
      color = theme.red[300];
      text = newText || "Canceled Bid";
      break;
    case ProposalState.DECLINED_BID:
      color = theme.brand2[750];
      text = newText || "Declined Bid";
      break;
    case ProposalState.PENDING:
      color = theme.purple[200];
      text = newText || "Pending";
      break;
    case ProposalState.LIKED:
      color = theme.grey2[500];
      text = newText || "Liked";
      break;
    default:
      color = theme.grey2[500];
      text = newText || "None";
      break;
  }

  return { color, text };
}

export { getStateData };
